import React, {useState} from 'react';
import JsxParser from 'react-jsx-parser';
import '../../../assets/css/accordion.css';
import {PATH} from "../../../config";

const FagMore = () => {
    const [selected, setSelected] = useState(null);
    const toggle = (i) => {
        if(selected === i) {
            return setSelected(null)
        }
        setSelected(i);
    }
    return (
        <div className="container mx-auto px-12 relative pt-162 min-h-calc-head py-8">
        <div className="wrapper mt-20">
            <h1 className="text-white text-5xl font-extralight mb-12">FAQ</h1>
            <div className="accordion">
                {data.map((item, i) => (
                    <div className="item mb-4" key={i}>
                        <div className="fag-head title bg-indigo-900 hover:bg-indigo-400 rounded-md py-5 px-8 flex items-center justify-between gap-x-4" onClick={() => toggle(i)}>
                            <h2 className="font-medium text-lg text-white mb-0">{item.question}</h2>
                            <img src={selected === i ? PATH + 'arrow-up.svg' : PATH + 'arrow-down.svg'} alt=""/>
                        </div>
                        <div className={`text-base text-gray-300 ${selected === i ? 'content show' : 'content'}`}>
                            <div className="py-5">
                                <JsxParser
                                    jsx={item.answer}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
        </div>
    )
}


const data = [
    {
        question: 'How to buy Land Plots and Metahuts?',
        answer: `Below are a few resources you can use to <b>learn how to buy</b> Land plots and Metahuts step-by-step:
            <ul className="list-circle pl-9">
                <li className="mt-2"><a href="https://medium.com/@metafluence/how-to-buy-land-plots-in-metafluence-city-75b8671fb14c" target="_blank" rel="noreferrer" className="underline text-cyan-500">Blog post</a> (ENG)</li>
                <li className="mt-2"><a href="https://www.youtube.com/watch?v=XIyqCPeV_eQ&feature=youtu.be" target="_blank" rel="noreferrer" className="underline text-cyan-500">Video guide</a> (ENG)</li>
                <li className="mt-2"><a href="https://www.youtube.com/watch?v=bw01pSiiJeQ&feature=youtu.be" target="_blank" rel="noreferrer" className="underline text-cyan-500">Video guide</a> (RU)</li>
                <li className="mt-2"><a href="https://www.youtube.com/watch?v=c_JJCwEhg3U&feature=youtu.be" target="_blank" rel="noreferrer" className="underline text-cyan-500">Video guide</a> (TR)</li>
            </ul>`
    },
    {
        question: 'Is it possible to purchase Land Plots & Metahuts on mobile?',
        answer: `Yes, you can acquire Land Plots or Metahuts through Metamask mobile application with just a few clicks. The process is similar to how it’s on desktop, but we also created a detailed <a href="https://medium.com/@metafluence/how-to-buy-land-plots-in-metafluence-city-75b8671fb14c#5fcf" target="_blank" className="text-cyan-500"><i>step-by-step guide</i></a>.`
    },
    {
        question: 'What is the main difference between a Land Plot and Metahut?',
        answer: `Metahuts are virtual residences in Metafluence Metaverse consisting of different rooms such as <b>NFT, Event, Shopping</b> and other customizable rooms in the future, allowing the owners to engage with their audiences and brands easily.
        <br/><br/><p>Land Plots are <b>100M x 100M</b> square spaces in <i>Metafluence City</i> that offer numerous benefits, including hosting public events, receiving NFT airdrops, etc. Besides, <i>Land plots</i> can be upgraded into Metahuts to provide more features and benefits in the future.</p>`
    },
    {
        question: 'What are the main benefits of Land Plots & Metahuts?',
        answer: `Land Plots and Metahuts offer a wide range of benefits in the Metaverse. For instance, by having a Metafluence Land Plot, you’ll be able to host public & “open-air” events, receive <b>NFT airdrops</b>, or even upgrade your land to a Metahut for adding more features in the future.
        <br/><br/><p>On the other hand, Metahut is a unique multi-purpose Metaverse residence with numerous advantages. It consists of different customizable rooms, such as Event, NFT, and Shopping Rooms, where you can <b>host public and private events, exhibit NFTs, or even sell your products in a personalized marketplace.</b> All these great features will enable Metahut owners to <b>engage with their fans and brands</b> in a seamless manner while providing them with an unparalleled experience.</p>`,
    },
    {
        question: 'What kind of events can I host in my Event Room?',
        answer: `Long story short, you can organize <b>meetings, parties, presentations,</b> etc., in your Event Room. What about the details?
        <br/><br/><p>As the Metafluence ecosystem is commercially oriented, the main focus of the events is to allow individuals to monetize their <i>social media reach</i> and influence, whether it’s audience participation or brand sponsorships. The events can be held as <b>Public events</b> (accessible by everyone) or <b>Private events</b> (accessible for the event ticket holders).</p>`,
    },
    {
        question: 'Can I add additional rooms to my Metahut in the future?',
        answer: `Yes, you can! While Event, NFT, and Shopping Rooms are the fundamental constituents within every Metahut, <b><i>you’ll also be able to add other customizable rooms in your virtual home.</i></b> We will share relevant details about this feature in the future, so stick with us not to miss any updates.`
    },
    {
        question: 'Are Land Plots & Metahuts only intended for influencers?',
        answer: `The good news is, they are <b>absolutely not!</b> Metafluence is an <b><i>influencer-centric metaverse aimed at bringing influencers, brands, and their audiences together under the same roof.</i></b> That way, by attracting lots of people from all over the world, the Metafluence City will be an <b><i>irreplaceable platform for everyone to shine and become a metapreneur.</i></b> So <b>everybody can acquire Land Plots & Metahuts and become a Metafluence citizen.</b>`,
    },
    {
        question: 'Will there be any limit on Land & Metahut Purchases?',
        answer: 'Yes and No. There <i>will be a limit for Land Plots, but not for Metahuts.</i> That is, you can purchase only <b>94 Land Plots</b> but <b>as many Metahuts as you want</b> with a single wallet. However, keep in mind that, in <i>Volume 1 Sale</i>, only <b>240 Metahuts</b> and <b>23,700 Land Plots</b> are up for sale in total.'
    },
    {
        question: 'What are the prices for Land Plots & Metahuts?',
        answer: `Land Plot and Metahut prices will vary depending on the means of payment.
        <br/><br/><p><b>Whitelist Sale prices:</b></p>
        <ul className="list-circle pl-9">
            <li className="mt-2">If bought <b>with $METO:</b>
                <ul className="list-circle pl-9">
                    <li className="mt-2">Land Plot: $85</li>
                    <li className="mt-2">Metahut: $3500</li>
                </ul>
            </li>
            <li className="mt-2">If bought <b>with $BUSD:</b>
                <ul className="list-circle pl-9">
                    <li className="mt-2">Land Plot: $95</li>
                    <li className="mt-2">Metahut: $3700</li>
                </ul>
            </li>
        </ul>
        <p><b>Public Sale prices:</b></p>
        <ul className="list-circle pl-9">
            <li className="mt-2">If bought <b>with $METO:</b>
                <ul className="list-circle pl-9">
                    <li className="mt-2">Land Plot: $95</li>
                    <li className="mt-2">Metahut: $3700</li>
                </ul>
            </li>
            <li className="mt-2">If bought <b>with $BUSD:</b>
                <ul className="list-circle pl-9">
                    <li className="mt-2">Land Plot: $105</li>
                    <li className="mt-2">Metahut: $4150</li>
                </ul>
            </li>
        </ul>
        <br/><br/><p><i>Aside from the required $METO/$BUSD</i> amount, <b>a small amount of $BNB is also required to pay for the transaction fees.</b></p>`,
    },
    {
        question: 'Can I choose the location of my Land & Metahut?',
        answer: `Yes, you can!  First, you have to choose the location of Land Plots. <b>Available virtual spots will be gray-colored on the map,</b> so differentiating them will be easy for you. <b>Metahuts,</b> on the other hand, are <b>acquired and placed on the existing Land Plots.</b>
        <br/><br/><p>The sooner you decide to acquire the properties, the better locations you’ll be able to find.</p>`
    },
    {
        question: `Why can't I see my Land Plots NFTs in my MetaMask wallet?`,
        answer: `In order to see your Land Plots NFTs in your MetaMask wallet, you have to import your Land Plot’s contract address and collectible IDs. To do that, open your MetaMask wallet on Mobile (make sure you’re on BSC network), click on “NFTs” tab, then “Import NFTs” and enter the corresponding details:
        <br/><br/><p><b>Address: <i>0xb20b17a146D0CeAAAeC707a3703d790139f747bf</i></b></p>
        <br/><p>ID: Each <i>Land Plot has its own unique ID. In order to get the ID of the Land Plot that you’ve acquired,</i> you’ll need to go to <a href="https://app.metafluence.com/city/" target="_blank" className="text-cyan-500">Metafluence City Map</a>, hover the mouse over the Land Plots that you own and you’ll see the ID written on each of the Land Plots. Copy it and enter in the “ID” section of the MetaMask and then click “Import”.</p>
        <br/><p>Done! Now you should see your Land Plots NFTs in your MetaMask wallet, in NFTs section.</p>`
    },
    {
        question: 'What do yellow, gray, and red colors mean on the Metafluence City Map?',
        answer: `There’re lots of Land Plots on the Metafluence City Map, and you can differentiate their status based on their color. 🟡 Yellow means the Land Plot has been reserved, ⚪️ gray means it’s still available, and 🔴 red means the land already has an owner.`
    },
    {
        question: 'How can I claim my land plot? (For the launchpad users and land winners)',
        answer: `You can claim your virtual properties with your MetaMask wallet on Metafluence City Map (desktop only):
        <br/><a href="https://app.metafluence.com/city/" target="_blank" className="text-cyan-500">https://app.metafluence.com/city/</a>
        <br/><br/><p>If the wallet that you’ve used during the Launchpad Sale or a certain campaign is not a MetaMask wallet, then <b>you’ll need to transfer it to MetaMask</b>. We’ve prepared a detailed guide on how to do that, see the link for details: <a href="https://bit.ly/3npIWVs" target="_blank" className="text-cyan-500">https://bit.ly/3npIWVs</a></p>`
    },
];

export default FagMore;